import type { ClaimGoogleTransLang, StreamStatus } from '@/domains/claim-charting/types/enum';
import type { PsHttpSSE } from '@patsnap-utils/sse';

export interface ApiGetClaimFeatureRequest {
    type: 'patent' | 'freetext';
    patent_id?: string;  // type=patent 时必填（后端参数名）
    content?: string;   // type=freetext 时必填
}

interface SeparateClaimItem {
    indep_claim: boolean;
    name: string;
    separates: string[];
}

export interface ApiGetClaimFeatureResponse {
    status: StreamStatus;
    token_usage: TokenUsage;
    content: ClaimFeatureContent;
}

export interface TokenUsage {
    input_token_count: number;
    output_token_count: number;
    total_token_count: number;
}
export interface ClaimFeatureContent {
    claim_lang?: ClaimGoogleTransLang;  // 文本类型可能没有
    patent_id?: string;                  // 文本类型没有
    pn?: string;                         // 文本类型没有
    separate_claims: SeparateClaimItem[];
}

export const GetClaimFeature = Symbol.for('GetClaimFeature');

export interface GetClaimFeature {
    getClaimFeature(request: ApiGetClaimFeatureRequest): PsHttpSSE<ApiGetClaimFeatureResponse>;
}
